"use client";

import { c as _c } from "react/compiler-runtime";
import { RefreshCw } from "lucide-react";
import { RecommendedSlotSection, SchedulingVerificationControls } from "@/src/components/comms/referral-scheduling-recommendation";
import { SchedulingEligibility } from "@/src/components/comms/scheduling-eligibility";
import { Button } from "@/src/components/shadcn/ui/button";
import { ValerieCard } from "@/src/components/valerie-card";
import { useUser } from "@/src/context/user-context";
import { useVerifySchedulingRecommendation } from "@/src/lib/data-fetchers/scheduling-fetchers";
import { useRegenerateTaskSchedulingRecommendation, useTaskSchedulingRecommendation } from "@/src/lib/data-fetchers/tasks-fetchers";
import { Referral } from "@/src/models/documents/referral";
import { shouldRecommendForSchedulingInReferralTask } from "@/src/models/scheduling-recommendation";
export function TaskSchedulingRecommendation(t0) {
  const $ = _c(21);
  const {
    taskId,
    referral,
    preferAgenticReceivingProvider: t1
  } = t0;
  const preferAgenticReceivingProvider = t1 === undefined ? false : t1;
  const {
    group
  } = useUser();
  const {
    recommendation,
    queryKey,
    isPending,
    isError
  } = useTaskSchedulingRecommendation(taskId);
  const regenerate = useRegenerateTaskSchedulingRecommendation(taskId);
  const verify = useVerifySchedulingRecommendation(referral.id, queryKey);
  const isMutating = regenerate.isPending || verify.isPending;
  const t2 = isPending || isMutating;
  let t3;
  if ($[0] !== regenerate) {
    t3 = () => regenerate.mutate();
    $[0] = regenerate;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `mr-1 h-3.5 w-3.5 ${regenerate.isPending ? "animate-spin" : ""}`;
  let t5;
  if ($[2] !== t4) {
    t5 = <RefreshCw className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = regenerate.isPending ? "Regenerating..." : "Regenerate";
  let t7;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t5 || $[7] !== t6) {
    t7 = <Button size="sm" variant="outline" disabled={t2} onClick={t3}>{t5}{t6}</Button>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== group || $[10] !== isError || $[11] !== isMutating || $[12] !== isPending || $[13] !== preferAgenticReceivingProvider || $[14] !== recommendation || $[15] !== referral.receivingProvider || $[16] !== verify) {
    t8 = isPending ? <p className="text-sm text-muted-foreground">Checking for eligibility...</p> : isError ? <p className="text-sm text-muted-foreground">Unable to load recommendation.</p> : recommendation ? <div className="space-y-2"><div className="flex items-center gap-2 text-sm font-medium">{shouldRecommendForSchedulingInReferralTask(group, recommendation) ? "Recommended" : "Not Recommended"}<SchedulingEligibility agenticRecommendation={recommendation.agenticRecommendation} receivingProvider={referral.receivingProvider} preferAgenticReceivingProvider={preferAgenticReceivingProvider} /></div><RecommendedSlotSection recommendation={recommendation} /><SchedulingVerificationControls isCorrect={recommendation.isCorrect} verificationReason={recommendation.verificationReason} isPending={isMutating} onMarkCorrect={() => verify.mutate({
        isCorrect: recommendation.isCorrect === true ? null : true,
        verificationReason: null
      })} onMarkIncorrect={reason => verify.mutate({
        isCorrect: false,
        verificationReason: reason
      })} onClear={() => verify.mutate({
        isCorrect: null,
        verificationReason: null
      })} /></div> : <p className="text-sm text-muted-foreground">No scheduling recommendation available.</p>;
    $[9] = group;
    $[10] = isError;
    $[11] = isMutating;
    $[12] = isPending;
    $[13] = preferAgenticReceivingProvider;
    $[14] = recommendation;
    $[15] = referral.receivingProvider;
    $[16] = verify;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <ValerieCard title="Scheduling recommendation" actions={t7}>{t8}</ValerieCard>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}